// Vendors
import $ from 'jquery';

// Helpers
import { setCountrySelectOptions, setStateSelectOptions } from '../lib/helpers';

const $wpcf7Forms = $('.wpcf7-form');

$wpcf7Forms.each((index, form) => {
  const $form = $(form);
  const $countrySelect = $form.find('select[name="country"]');
  const $stateSelect = $form.find('select[name="state"]');
  const $submitButton = $form.find('.wpcf7-submit');

  if ($countrySelect) setCountrySelectOptions($countrySelect);

  if ($stateSelect) {
    setStateSelectOptions($stateSelect);

    $countrySelect.on('input', event => {
      const { value } = event.target;
      setStateSelectOptions($stateSelect, value);
    });
  }

  if ($submitButton) {
    $submitButton.on('click', event => {
      $submitButton.val('Submitting...');
      $submitButton.prop('disabled', true);
      $form.submit();
    });

    document.addEventListener('wpcf7submit', event => {
      $submitButton.prop('disabled', false);
      const status = event.detail.status;
      if (status) {
        $submitButton.val('Submit');
      }
    });
  }
});
